import React from 'react';
import {View, ScrollView, StyleSheet} from 'react-native';
import {Text, Appbar, RadioButton, List} from 'react-native-paper';
import {useTranslation} from 'react-i18next';
import {useNavigation} from '@react-navigation/native';
import {colors, spacing} from '../../theme';

const LANGUAGES = [
  {code: 'en', label: 'English', available: true},
  {code: 'hi', label: 'Hindi', available: false},
  {code: 'ta', label: 'Tamil', available: false},
  {code: 'te', label: 'Telugu', available: false},
  {code: 'kn', label: 'Kannada', available: false},
];

const LanguageScreen = () => {
  const {t, i18n} = useTranslation();
  const navigation = useNavigation();

  const handleChange = code => {
    i18n.changeLanguage(code);
  };

  return (
    <View style={styles.container}>
      <Appbar.Header style={styles.appbar} dark>
        <Appbar.BackAction onPress={() => navigation.goBack()} color={colors.white} />
        <Appbar.Content title={t('settings.language')} titleStyle={styles.appbarTitle} />
      </Appbar.Header>

      <ScrollView>
        <RadioButton.Group value={i18n.language} onValueChange={handleChange}>
          {LANGUAGES.map(lang => (
            <List.Item
              key={lang.code}
              title={lang.label}
              description={!lang.available ? 'Coming Soon' : undefined}
              disabled={!lang.available}
              style={[styles.listItem, !lang.available && styles.disabledItem]}
              titleStyle={!lang.available ? styles.disabledText : undefined}
              left={() => (
                <RadioButton
                  value={lang.code}
                  disabled={!lang.available}
                  color={colors.primary}
                />
              )}
            />
          ))}
        </RadioButton.Group>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {flex: 1, backgroundColor: colors.background},
  appbar: {backgroundColor: colors.primary},
  appbarTitle: {color: colors.white},
  listItem: {backgroundColor: colors.surface, marginBottom: 1},
  disabledItem: {opacity: 0.5},
  disabledText: {color: colors.textSecondary},
});

export default LanguageScreen;
